import React from 'react';
import {AppBar, Toolbar, useTheme} from '@mui/material';
import {Logo} from 'components/svg';

export const TopBarAnon: React.FC = () => {
  const {palette} = useTheme();
  return (
    <AppBar
      position="static"
      sx={{
        backgroundClip: 'padding-box',
      }}>
      <Toolbar
        disableGutters
        sx={{
          paddingX: 3,
          justifyContent: 'space-between',
          background: palette.primary.main,
        }}>
        <Logo />
      </Toolbar>
    </AppBar>
  );
};
